"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.quickOffer.name': '快速报价',
    'tools.quickOffer.description': '根据配置的字段和选项，从用户消息中收集快速报价表单字段',
};
